import { FC } from 'react'
import { ContentContainer } from '../../../../components/custom_components/ContentContainer'
import { LoadingAndErrors } from '../../../../components/custom_components/LoadingAndErrors'
import { CurrencyFromContractProvider } from '../../../../context/currency-context'
import { useMeetingManagerPreparation } from '../../../../graphql/meeting/hooks/useMeetingManager'
import { useCollapse } from '../../../../routes/collapse-context'
import { MeetingType } from '../../../../types'
import ManagerPrepareOtherMeeting from '../../../otherMeetings/ManagerPrepareOtherMeeting'
import { MeetingViewProps } from '../shared/appraisal-types'
import ManagerPrepareMeetingView from './ManagerPrepareMeetingView'
import { useAuth } from '../../../../context/auth-context'

const ManagerPrepareViewContainer: FC<MeetingViewProps> = ({ match }) => {
  const meetingId = match.params.id
  const collapsed = useCollapse()
  const { user } = useAuth()

  const { data, error, loading } = useMeetingManagerPreparation(meetingId)

  if (
    loading ||
    error ||
    !data ||
    !data.meetingManagerPreparation ||
    !data.meetingManagerPreparation.reviewer ||
    data.meetingManagerPreparation.managerPrepared ||
    data.meetingManagerPreparation.reviewer.id !== user.employeeId
  ) {
    return (
      <ContentContainer collapsed={collapsed}>
        <LoadingAndErrors
          isLoading={loading}
          hasNoData={!data || !data.meetingManagerPreparation || !data.meetingManagerPreparation.reviewer}
          error={error}
          isPermissionDenied={
            !error &&
            !!data &&
            !!data.meetingManagerPreparation &&
            !!data.meetingManagerPreparation.reviewer &&
            (data.meetingManagerPreparation.managerPrepared || data.meetingManagerPreparation.reviewer.id !== user.employeeId)
          }
        />
      </ContentContainer>
    )
  }

  const meetingType = data.meetingManagerPreparation.type

  return (
    <CurrencyFromContractProvider employeeId={data.meetingManagerPreparation.employee.id}>
      {meetingType === MeetingType.Appraisal || meetingType === MeetingType.AppraisalUpdate ? (
        <ManagerPrepareMeetingView meeting={data.meetingManagerPreparation} />
      ) : (
        <ManagerPrepareOtherMeeting meeting={data.meetingManagerPreparation} />
      )}
    </CurrencyFromContractProvider>
  )
}

export default ManagerPrepareViewContainer
